import { useState } from 'react';
import { api } from '../api';
import { FeatureModel } from '../interfaces/feature';

export type KanoCategoryType = 'Must-Be' | 'Performance' | 'Attractive' | 'Indifferent' | 'Reverse' | 'Questionable';

export interface KanoPredictionResult {
  reasoning: string;
  summary: string;
  categories: KanoCategory[];
}

export interface KanoCategory {
  type: KanoCategoryType;
  features: FeatureModel[];
}

export const useKanoPrediction = () => {
  const [loading, setLoading] = useState(false);

  const delay = (ms: number) => new Promise((resolve) => setTimeout(resolve, ms));
  const mock = async () => {
    await delay(1000);
    return {
      reasoning: "The Kano model categorizes features based on customer satisfaction and necessity. 'Must-Be' features are basic expectations, 'Performance' features increase satisfaction linearly, 'Attractive' features delight customers, 'Indifferent' features have no impact on satisfaction, 'Reverse' features cause dissatisfaction if present, and 'Questionable' features are unclear. The 'Login' feature is a basic expectation for most web applications, so it is categorized as 'Must-Be'. 'Daten erfassen' is a standard functionality for data input, also a 'Must-Be' feature. The 'KI Feature' is likely an 'Attractive' feature as it offers advanced functionality that can delight users.",
      summary: "Lorem ipsumg",
      categories: [
        {
          type: "Must-Be" as KanoCategoryType,
          features: [
            {
              name: "Login",
              description: "login"
            },
            {
              name: "Daten erfassen",
              description: "Ich muss was eingeben können"
            }
          ]
        },
        {
          type: "Attractive" as KanoCategoryType,
          features: [
            {
              name: "KI Feature",
              description: "Ich will Sachen mit KI generieren lassen"
            }
          ]
        }
      ]
    };
  };

  const makePrediction = async (features: FeatureModel[], productInformation: string): Promise<KanoPredictionResult> => {
    setLoading(true);

    try {
      const response = await api.makePrediction<KanoPredictionResult>(
        'Kategorisiere die folgenden Features in das Kanomodell ein. Nutze die Produktinformationen um die Features besser zu verstehen. Schreibe eine kurze Zusammenfassung zur Einschätzung in deutscher Sprache. Explain your easoning',
        JSON.stringify({ ...features, productInformation }),
        `z.object({
          reasoning: z.string(),
          summary: z.string(),
          categories: z.array(
            z.object({
              type: z.enum(["Must-Be", "Performance", "Attractive", "Indifferent", "Reverse", "Questionable"]),
              features: z.array(
                z.object({
                  name: z.string(),
                  description: z.string(),
                })
              ),
            })
          ),
        })         
        `,
      );

      return response;
    } finally {
      setLoading(false);
    }
  };

  return {
    loading,
    makePrediction
  };
};

// const mock = {
//   "json": {
//       "reasoning": "The Kano model categorizes features based on customer satisfaction and necessity. 'Must-Be' features are basic expectations, 'Performance' features increase satisfaction linearly, 'Attractive' features delight customers, 'Indifferent' features have no impact on satisfaction, 'Reverse' features cause dissatisfaction if present, and 'Questionable' features are unclear. The 'Login' feature is a basic expectation for most web applications, so it is categorized as 'Must-Be'. 'Daten erfassen' is a standard functionality for data input, also a 'Must-Be' feature. The 'KI Feature' is likely an 'Attractive' feature as it offers advanced functionality that can delight users.",
//       "categories": [
//           {
//               "type": "Must-Be",
//               "features": [
//                   {
//                       "name": "Login",
//                       "description": "login"
//                   },
//                   {
//                       "name": "Daten erfassen",
//                       "description": "Ich muss was eingeben können"
//                   }
//               ]
//           },
//           {
//               "type": "Attractive",
//               "features": [
//                   {
//                       "name": "KI Feature",
//                       "description": "Ich will Sachen mit KI generieren lassen"
//                   }
//               ]
//           }
//       ]
//   },
//   "question": "{\"0\":{\"name\":\"Login\",\"description\":\"login\"},\"1\":{\"name\":\"Daten erfassen\",\"description\":\"Ich muss was eingeben können\"},\"2\":{\"name\":\"KI Feature\",\"description\":\"Ich will Sachen mit KI generieren lassen\"},\"productInformation\":\"Das ist meine Webseite\"}",
//   "chatId": "2600f232-20c0-40c8-bd9d-df0b251eebcc",
//   "chatMessageId": "c18054a1-e832-4870-a208-d043807027a9",
//   "sessionId": "2600f232-20c0-40c8-bd9d-df0b251eebcc"
// }